import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-exclamation-circle-fill",
  style: {"color":"var(--cor_layout_1) !important","font-size":"30px"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sign-out" }, null, -1)
const _hoisted_4 = { class: "row g-4" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "CPF:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Telefone:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)

import RequiredCheckModal from '@/components/modals/geral/RequiredCheckModal.vue'
import { computed, ref, reactive, watch } from 'vue'
import { UserStore } from '@/pinia/user/UserStore'
import { UpdadteUserPendingData, UsuarioModel } from '@/models/UsuarioModel'
import UltilChanges from '@/composables/UtilChanges'
import useEmitter from '@/composables/Emmiter'
import useUserPendingDataModal from '@/layout/UserPendingDataModal/composables/UserPendingDataModal'
import { usuarioAtualizarDadosPendentes } from '@/services/UsuarioService'
import useAlert from '@/composables/Alert'
import { UserPendingDataModalNotificatioType } from '@/layout/UserPendingDataModal/composables/types'
import moment from 'moment'

/** Config */
const useTerms = 'https://sgsipoliticaprivacidade.blob.core.windows.net/acampapolicy/Termo_de_uso.pdf'
const privacyPolicy = 'https://sgsipoliticaprivacidade.blob.core.windows.net/acampapolicy/Politica_de_privacidade.pdf'

/** Methods */

export default /*#__PURE__*/_defineComponent({
  ...{
  name: 'UserPendingDataModal',
},
  __name: 'UserPendingDataModal',
  setup(__props) {



/** Variables */
const enabled = ref(false)
const isLoading = ref(false)
const userStore = UserStore()
const formRef = ref<null | HTMLFormElement>(null)
const userForm = reactive({
  cpf: '',
  telefone: ''
})
const {
  validateCPF,
  validatePhoneBR
} = UltilChanges()
const rules = ref({
  cpf: [
    {
      required: true,
      validator: validateCPF,
      trigger: "change"
    }
  ],
  telefone: [
    {
      required: true,
      // message: "Telefone obrigatório",
      validator: validatePhoneBR,
      trigger: "change"
    }
  ]
})
const {
  LOCALSTORAGE_ACTIVATION_DATE_KEY,
  SET_NOTIFICATION,
  UNSET_NOTIFICATION,
  setActivationTime,
} = useUserPendingDataModal()
const userPendingDataModalNotificatio: UserPendingDataModalNotificatioType = {
  titulo: 'Atualizações Pendentes',
  id: SET_NOTIFICATION,
  executar() {
    userForm.cpf = userStore.getUser?.cpf || ''
    userForm.telefone = userStore.getUser?.telefone || ''
    enabled.value = true
    emitter.emit(UNSET_NOTIFICATION, { id: SET_NOTIFICATION })
  }
}
const emitter = useEmitter()
const { showTimeAlert } = useAlert()
const executeBtnDisabled = computed(() => !(userForm.cpf && userForm.telefone))
const cpfFieldDisabled = computed(() => !!(userStore.getUser?.cpf))
function handleEnableModal(user: UsuarioModel | null) {
  try {
    const updated = user && (typeof user.usuarioAtualizado === "boolean" || typeof user.usuarioAtualizado === "number")
      ? !!user.usuarioAtualizado
      : true

    if (!updated) {
      const activationDate = window.localStorage.getItem(LOCALSTORAGE_ACTIVATION_DATE_KEY)
      const now = moment().valueOf()
      if (!activationDate || (activationDate && +activationDate < now)) {
        userForm.cpf = user?.cpf || ''
        userForm.telefone = user?.telefone || ''
        enabled.value = true
      } else {
        emitter.emit(SET_NOTIFICATION, { ...userPendingDataModalNotificatio })
      }
    }
  } catch (error){
    console.error(error)
  }
}

function handleDisableModal() {
  try {
    const activationDate = window.localStorage.getItem(LOCALSTORAGE_ACTIVATION_DATE_KEY)
    if (!activationDate)
      throw new Error()
    const now = moment().valueOf()
    if(now > +activationDate)
      setActivationTime(1, 'day')
  } catch (error) {
    setActivationTime(1, 'day')
  }
  enabled.value = false
}

const submit = () => {
  if (!formRef.value)
    return;

  formRef.value.validate((valid) => {
    if (!valid)
      return

      isLoading.value = true

      savePendingData({
        cpf: userForm.cpf.replace(/\D/g, ''),
        telefone: userForm.telefone.replace(/\D/g, ''),
      })
  })
}

async function savePendingData(pendingData: UpdadteUserPendingData) {
  await usuarioAtualizarDadosPendentes(pendingData)
    .then((response) => {
      if(!response.error)
        showTimeAlert(response.message)
    })
    .catch(e => {
      console.error(e)
      showTimeAlert(e.data?.message ?? 'Não foi possível completar a solicitação', "error")
    })
    .finally(() => {
      enabled.value = false
      isLoading.value = false
    })
}

/** Life Cycles */
watch(() => userStore.getUser, (value: UsuarioModel | null) => handleEnableModal(value), { immediate: true, deep: true })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(RequiredCheckModal, {
    title: "Atualizações Pendentes",
    "sub-title": "Atualize os dados de seu cadastro",
    enabled: enabled.value,
    onDisabled: handleDisableModal,
    "logout-btn-enabled": false,
    "is-loading": isLoading.value,
    "execute-btn-name": "Salvar",
    "execute-btn-disabled": executeBtnDisabled.value,
    onExecuteClick: () => submit()
  }, {
    headerIcon: _withCtx(() => [
      _hoisted_1
    ]),
    executeBtnIcon: _withCtx(() => [
      _hoisted_2
    ]),
    footerBtnSecondaryIcon: _withCtx(() => [
      _hoisted_3
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "demo-ruleForm",
        model: userForm,
        rules: rules.value,
        "status-icon": "",
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_form_item, { prop: "cpf" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_input, {
                    type: "text",
                    modelValue: userForm.cpf,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userForm.cpf) = $event)),
                    disabled: cpfFieldDisabled.value
                  }, null, 8, ["modelValue", "disabled"]), [
                    [_directive_maska, '###.###.###-##']
                  ]),
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_form_item, { prop: "telefone" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_input, {
                    type: "text",
                    modelValue: userForm.telefone,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userForm.telefone) = $event))
                  }, null, 8, ["modelValue"]), [
                    [_directive_maska, ['(##) #####-####', '(##) ####-####']]
                  ]),
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-sm-12" }, [
          _createTextVNode(" Consulte nossos "),
          _createElementVNode("a", {
            href: useTerms,
            target: "_blank"
          }, "Termos de Uso"),
          _createTextVNode(" e "),
          _createElementVNode("a", {
            href: privacyPolicy,
            target: "_blank"
          }, "Política de Privacidade"),
          _createTextVNode(". ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["enabled", "is-loading", "execute-btn-disabled", "onExecuteClick"]))
}
}

})